import { CREATE_CATEGORY } from '../config';

export default function (state = null, action) {
    switch (action.type) {
        case CREATE_CATEGORY:
            return action.payload;
        default:
            return state;
    }
}
